'use strict';

import ngResource from 'angular-resource';

class DemandLevelService {
  constructor($resource) {
    'ngInject';
    this.api = $resource(
      '/api/demand_level/:id',
      { id: '@id' },
      { 
        update: { method: 'PUT', isArray: false },
        show  : { method: 'GET', isArray: false }
      }
    );

    this.oem_api = $resource(
      '/api/oem/demand_level/:id',
      { id: '@id' },
      { 
        update: { method: 'PUT', isArray: false },
        show  : { method: 'GET', isArray: false }
      }
    )
  }
}

export default angular.module('leptonApp.DemandLevelService', ['ngResource'])
  .service('DemandLevelService', ['$resource', DemandLevelService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/demand_level/demand_level.service.js